import { Role } from '~/common/providers/auth/role';

// The roles can access the currencies section.
export const CURRENCIES_ALLOWED_ROLES: Role[] = [
  'LOGLASS_SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'CORP_PLANNING',
];
